import React, { useEffect } from 'react';
import { Menu } from 'semantic-ui-react';

const Tabs = ({ getPublishers, activeItem, setActiveItem, provider }) => {
  useEffect(() => {
    if (activeItem === 'adSpace') {
      getPublishers({
        type: 'pubAdspaces',
        filter: { userType: ['publisher'] },
        provider
      });
    }
    if (activeItem === 'Date') {
      getPublishers({
        type: 'adminDate',
        filter: { userType: ['publisher'] },
        provider
      });
    }
    if (activeItem === 'Country') {
      getPublishers({
        type: 'country',
        filter: { userType: ['publisher'] },
        provider
      });
    }
  }, [activeItem, getPublishers]);
  return (
    <Menu pointing secondary color="blue">
      <Menu.Item
        name="Date"
        active={activeItem === 'Date'}
        onClick={() => setActiveItem('Date')}
      />
      <Menu.Item
        name="Ad Space"
        active={activeItem === 'adSpace'}
        onClick={() => setActiveItem('adSpace')}
      />
      <Menu.Item
        name="Country"
        active={activeItem === 'Country'}
        onClick={() => setActiveItem('Country')}
      />
    </Menu>
  );
};

export default Tabs;
